import { type IClientResponse, Query } from "@gen/app-query";
import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { Client } from "./Client";

const CLIENT_SETTINGS_DEFAULT_TITLE = "Client Settings";

export function createClientRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId",
    component: Client,
    staticData: { reducedMobileTopPadding: true },
    loader: ({ params, context }) => {
      const queryClient = context.queryClient;
      const queryKey = Query.core_getClientQueryKey(params.clientId);

      // `context` is untyped here because the route factory takes an AnyRoute
      // parent, which erases the router's AuthCtx context; cast the result.
      const cachedClient = queryClient.getQueryData(queryKey) as
        | IClientResponse
        | undefined;

      const calculateTitle = (prefix: string, name: string) => {
        return prefix + " " + name;
      };

      let titlePromise = queryClient
        .fetchQuery({
          queryKey,
          queryFn: () => Query.Client().core_getClient(params.clientId),
        })
        .then((r: IClientResponse) =>
          calculateTitle(CLIENT_SETTINGS_DEFAULT_TITLE, r.name),
        );

      if (cachedClient) {
        titlePromise = Promise.resolve(
          calculateTitle(CLIENT_SETTINGS_DEFAULT_TITLE, cachedClient.name),
        );
      } else {
        queryClient.prefetchQuery({
          queryKey,
          queryFn: () => Query.Client().core_getClient(params.clientId),
        });
      }

      return {
        titlePromise,
      };
    },
    head: () => ({
      meta: [
        {
          title: CLIENT_SETTINGS_DEFAULT_TITLE,
        },
      ],
    }),
  });
}
